var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanies(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M3.667 3.278V2.056a1.5 1.5 0 011.5-1.5h1.666a1.5 1.5 0 011.5 1.5v4.722h1.611a1.5 1.5 0 011.5 1.5v2.166a1 1 0 01-1 1h-.333V9.611a.5.5 0 10-1 0v1.833h-1.58c.016-.071.025-.145.025-.222v-1.11a1 1 0 00-1-1H5.444a1 1 0 00-1 1v1.11c0 .077.009.151.025.222H1.556a1 1 0 01-1-1V5.451a1 1 0 01.552-.894l2.559-1.28zm1.166 3.5a.389.389 0 100 .778.389.389 0 000-.778zm0-1.556a.389.389 0 100 .778.389.389 0 000-.778zm0-1.555a.389.389 0 100 .777.389.389 0 000-.777zm0-1.556a.389.389 0 100 .778.389.389 0 000-.778zm2.334 0a.389.389 0 100 .778.389.389 0 000-.778zm0 4.667a.389.389 0 100 .778.389.389 0 000-.778zm0-1.556a.389.389 0 100 .778.389.389 0 000-.778zm0-1.555a.389.389 0 100 .777.389.389 0 000-.777zM9.5 7.556a.389.389 0 100 .777h.222a.389.389 0 100-.777H9.5zm-7 .777a.389.389 0 000 .778h.222a.389.389 0 100-.778H2.5zm0-1.555a.389.389 0 100 .778h.222a.389.389 0 000-.778H2.5zm0-1.556A.389.389 0 002.5 6h.222a.389.389 0 000-.778H2.5z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default ForwardRef;